module.exports = __webpack_public_path__ + "img/cdn.b945d726.svg";